import { z } from 'zod';
import { CORES_ATENDENTE, type CorAtendente } from './cores';
import { ABAS, PAPEIS, STATUS_ATENDENTE, VEZ } from './dominio';

export const loginSchema = z.object({
  email: z.string().trim().toLowerCase().email('E-mail inválido'),
  senha: z.string().min(1, 'Informe a senha'),
});
export type LoginInput = z.infer<typeof loginSchema>;

const corSchema = z.enum(CORES_ATENDENTE as [CorAtendente, ...CorAtendente[]]);

export const criarAtendenteSchema = z.object({
  nome: z.string().trim().min(2, 'Nome muito curto').max(80),
  nomeExibicao: z.string().trim().min(2, 'Nome de exibição muito curto').max(24),
  email: z.string().trim().toLowerCase().email('E-mail inválido'),
  senha: z.string().min(8, 'A senha precisa de pelo menos 8 caracteres'),
  papel: z.enum(PAPEIS),
  cor: corSchema.optional(),
});
export type CriarAtendenteInput = z.infer<typeof criarAtendenteSchema>;

export const editarAtendenteSchema = criarAtendenteSchema
  .omit({ senha: true })
  .partial()
  .extend({ ativo: z.boolean().optional(), senha: z.string().min(8).optional() });
export type EditarAtendenteInput = z.infer<typeof editarAtendenteSchema>;

export const meuStatusSchema = z.object({ status: z.enum(STATUS_ATENDENTE) });

export const listarConversasSchema = z.object({
  aba: z.enum(ABAS).default('minhas'),
  vez: z.enum(VEZ).optional(),
  busca: z.string().trim().max(100).optional(),
  atendenteId: z.string().uuid().optional(),
});
export type ListarConversasInput = z.infer<typeof listarConversasSchema>;

export const enviarMensagemSchema = z.object({
  texto: z.string().trim().min(1, 'Mensagem vazia').max(4096),
  respondeAId: z.string().uuid().optional(),
});
export type EnviarMensagemInput = z.infer<typeof enviarMensagemSchema>;

export const observacaoSchema = z.object({
  texto: z.string().trim().min(1, 'Observação vazia').max(2000),
  fixada: z.boolean().default(false),
  salvarNoContato: z.boolean().default(false),
  mencionados: z.array(z.string().uuid()).default([]),
});
export type ObservacaoInput = z.infer<typeof observacaoSchema>;

export const transferirSchema = z.object({
  atendenteId: z.string().uuid(),
  observacao: z.string().trim().max(2000).optional(),
});
export type TransferirInput = z.infer<typeof transferirSchema>;

export const opcoesConversaSchema = z.object({
  silenciada: z.boolean().optional(),
  fixada: z.boolean().optional(),
  naoLida: z.boolean().optional(),
});

export const simularMensagemSchema = z.object({
  telefone: z.string().min(8),
  nome: z.string().trim().max(80).optional(),
  texto: z.string().trim().min(1).max(4096),
});
export type SimularMensagemInput = z.infer<typeof simularMensagemSchema>;
